"use client"

import Text from "@/components/common/Typography/Text"
import { faGlobe } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FC } from "react"

type SearchingCountryHeaderProps = {
  countryName: string
}

const SearchingCountryHeader: FC<SearchingCountryHeaderProps> = ({ countryName }) => {
  if (!countryName) {
    return null
  }
  return (
    <div className="home__searching--placement-country-header">
      <FontAwesomeIcon icon={faGlobe} className="home__searching--placement-header-icon" aria-hidden />
      <Text strong className="home__searching--placement-country-header-text">
        {countryName}
      </Text>
    </div>
  )
}

SearchingCountryHeader.displayName = "SearchingCountryHeader"

export default SearchingCountryHeader
